export default "__VITE_ASSET__CeF5dcCW__"